import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAuthAdmin from "../hooks/useAuthAdmin";

export default function PrivateRoutesAdmin({ children }) {
  const isLoggedIn = useAuthAdmin();

  const auth = useSelector((state) => state.auth);
  const { user } = auth;

  return isLoggedIn ? children : <Navigate to="/admin" />;
}
